import { Injectable } from '@angular/core';
import { LegacyImageFormat } from '../models/new/legacy-image-format';

@Injectable({
  providedIn: 'root'
})
export class LegacyImageFormatMapper {
  toLegacyImageFormat(node: any) {
    return new LegacyImageFormat({
      id: node.id,
      code: node.code,
      description: node.description,
      width: node.width,
      height: node.height,
      active: !!node.active,
      ord: node.ord,
      updateDate: node.updateDate ? new Date(node.updateDate) : undefined
    });
  }

  // Legacy formats are square: the side sets both width and height.
  toUpdateInput(format: LegacyImageFormat, size: number, active: boolean) {
    return { id: format.id, width: size, height: size, active };
  }
}
